import { getCountryDataList } from 'countries-list'

const countryList = getCountryDataList()
  .map(({ name, iso2, iso3, phone }) => ({
    name,
    alpha2Code: iso2,
    alpha3Code: iso3,
    callingCodes: phone.map(String)
  }))
  .sort((firstCountry, secondCountry) => firstCountry.name.localeCompare(secondCountry.name))

export const getCountryListAPICall = async () => {
  try {
    return { responseOk: 200, responseJSON: countryList }
  } catch (e) {
    console.error('ERROR: ', e)
    return e
  }
}
